module.exports = __webpack_public_path__ + "img/mobileiot6.2e2d24c1.png";